import React from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  useTheme,
  IconButton,
} from "@mui/material";
import { tokens } from "../components/Theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import NaturePeopleTwoToneIcon from "@mui/icons-material/NaturePeopleTwoTone";
import { useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";

function RegisterHeader() {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      width="100%"
      height="80px"
      sx={{ backgroundColor: colors.greenAccent[400] }}
      display="flex"
      justifyContent="space-between" // ✅ ซ้าย-ขวา
      alignItems="center"
      px={2} // ✅ เพิ่ม padding ซ้าย-ขวา
    >
      {/* ซ้าย */}
      <Box display="flex" alignItems="center">
        <NaturePeopleTwoToneIcon
          sx={{
            color: colors.grey[900],
            width: isMobile ? "40px" : "60px",
            height: isMobile ? "40px" : "60px",
            mr: "10px",
          }}
        />
        <Typography
          variant={isMobile ? "h5" : "h4"}
          fontWeight="bold"
          color="#fff"
        >
          ข้อมูลเกษตรกร
        </Typography>
      </Box>

      {/* ขวา */}
      <IconButton edge="end" onClick={() => navigate("/login")}>
        <LoginIcon sx={{ color: "#fff" }} />
      </IconButton>
    </Box>
  );
}

export default RegisterHeader;
